<template>
	<div @click="getDetail"
		 class="flex"
	>
		<i v-visible="iconClass" class="fa font_md" :class="[iconClass]" aria-hidden="true" style="margin-right: 5px; padding-top: 1px;"></i>
		<span class="pointer accent_color text-dense">{{ companyName }}</span>
	</div>
</template>

<script>
import {enumDef} from "@/common/enumDefs";
import {isValueSet} from "@/common/format";

export default {
	computed: {
		companyName() {
			return this.params.data[this.params.colDef.nameType];
		},
		companyId() {
			return this.params.data[this.params.colDef.idType];
		},
		iconClass() {
			const { colDef, data } = this.params;
			const statusType = colDef.investorCompanyConfigStatusType;

			if (!isValueSet(statusType) || !isValueSet(data[statusType])) {
				return '';
			}

			return enumDef.InvestorSellerDebtorConfigStatus.iconClass(data[statusType]);
		}
	},
    methods: {
        getDetail() {
            if (this.companyId) {
                this.$store.dispatch("setActionNoticModal", {
                    show: true,
                    data: {
                        type: "CompanyDetailsModal",
						title: this.companyName,
						width: 800,
                        data: { id: this.companyId }
                    }
                });
            }
        }
    }
};
</script>
